module.exports = __webpack_public_path__ + "media/images/hortense-for-wedding/Groupe 50-9f57975493e8200ebbfff900921710c3.png";